/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoIcon20Solid = forwardRef('TechCamVideoIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-.292l2.995 2.271c.823.625 2.005.037 2.005-.996V6.017c0-1.033-1.182-1.62-2.005-.996L15 7.29V7a3 3 0 0 0-3-3H4Z" })));
});
